import { useEffect } from 'react';
type FacebookPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  loaded?: boolean;
  push?: (...args: unknown[]) => void;
  queue?: unknown[][];
  version?: string;
};
declare global {
  interface Window {
    _fbq?: FacebookPixel;
    fbq?: FacebookPixel;
  }
}
const PIXEL_ID = '1022816640515647';
export function MetaPixel() {
  useEffect(() => {
    if (!window.fbq) {
      const pixel = ((...args: unknown[]) => {
        if (pixel.callMethod) {
          pixel.callMethod(...args);
          return;
        }
        pixel.queue?.push(args);
      }) as FacebookPixel;
      pixel.queue = [];
      pixel.loaded = true;
      pixel.version = '2.0';
      pixel.push = pixel;
      window._fbq = pixel;
      window.fbq = pixel;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return null;
}